import {Component, DestroyRef, Inject, inject, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {ClientService} from './client.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject, takeUntil} from 'rxjs';
import {ClientsRootPayloadModelList, CreateClientPayloadModel} from './client_interfaces';
import {MatProgressBar, MatProgressBarModule} from '@angular/material/progress-bar';
import { CommonModule, NgClass } from '@angular/common';
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow, MatRow,
  MatTable,
  MatTableDataSource, MatTableModule
} from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import {MatSort, MatSortModule} from '@angular/material/sort';
import {MatList, MatListItem, MatListModule} from '@angular/material/list';
import {MatDivider, MatDividerModule} from '@angular/material/divider';
import {MatIcon} from '@angular/material/icon';
import {MatButtonModule, MatFabButton, MatIconButton} from '@angular/material/button';
import {MatTooltip} from '@angular/material/tooltip';
import {MatFormField, MatFormFieldModule} from '@angular/material/form-field';
import {MatInput, MatInputModule} from '@angular/material/input';
import {MatCard, MatCardModule} from '@angular/material/card';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatToolbarModule} from '@angular/material/toolbar';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {
  CurrentCrudSelectBehaviorServiceAsString,
  CurrentSelectedClientIdBehaviorService,
  CurrentSelectedSlugBehaviorService,
  SnackBarService
} from '../objectPassingService';
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio';


export interface ClientsInterfaceData {
  client_id: number;
  client_slug: string;
  name: string;
}

export interface CreateClientInitPayload {
  is_edit: false;
}



@Component({
  selector: 'app-clients',
  imports: [
    MatProgressBar,
    MatList,
    MatListItem,
    MatDivider,
    MatIcon,
    MatFabButton,
    MatTooltip,
    MatFormField,
    MatInput,
    MatCard,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatPaginator,
    MatHeaderRow,
    MatRow,
    MatTableModule,
    MatFormFieldModule,
    MatSortModule,
    MatSort,
    NgClass,
    CommonModule,
    MatIconButton,
    MatRadioButton,
    FormsModule,
    MatRadioGroup
],
  templateUrl: './clients.component.html',
  standalone: true,
  styleUrl: './clients.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: []
})
export class ClientsComponent implements OnInit, OnDestroy {

  private destroyRef = inject(DestroyRef);
  destroyed = new Subject<void>();

  is_loading = false;
  selectedRowIndex: number | null = null;
  clients: ClientsRootPayloadModelList = [];
  client_id: number = 0;

  dataSource!: MatTableDataSource<ClientsInterfaceData>;
  displayedColumns: string[] = ['client_id', 'client_slug', 'name', 'Select', 'Edit', 'Delete'];

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  constructor(
    private route: ActivatedRoute, //all components need this
    public router: Router, //all components need this
    private clientService: ClientService,
    private currentSelectedSlugBehaviorService: CurrentSelectedSlugBehaviorService,
    private currentSelectedClientIdBehaviorService: CurrentSelectedClientIdBehaviorService,
    private currentCrudSelectBehaviorService: CurrentCrudSelectBehaviorServiceAsString,
    public dialog: MatDialog

  ) { }

  ngOnInit(): void {

    const client_id = localStorage.getItem('client_id');
    if (client_id) {
        this.client_id = parseInt(client_id, 10);
        this.currentSelectedClientIdBehaviorService.announceCurrentClientIdBehavior(parseInt(client_id, 10));
    }
    const client_slug = localStorage.getItem('client_slug');
    if (client_slug) {
      this.currentSelectedSlugBehaviorService.announceCurrentSlugBehavior(client_slug);
    }

    console.log('!!!!!!!!!!!!!!!!!!!client_id', client_id);
    console.log('!!!!!!!!!!!!!!!!!!!client_slug', client_slug);
    this.is_loading = false;
    this.getData(false)
  }


  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  getData(is_mocked:boolean = false) {
    this.is_loading = true;
    const show_deleted = 'false'
    console.log('WTF is_mocked', is_mocked);
    console.log('WTF this.is_loading', this.is_loading);
    //is_mocked = true;

    const is_selected = localStorage.getItem('client_id');


    this.clientService.getClients(`adserver/clients/all?show_deleted=${show_deleted}`, is_mocked).pipe(takeUntil(this.destroyed)).
    subscribe( (data: ClientsRootPayloadModelList) => {
        this.clients = data;
        //console.log('clients data!!!!!!!!!!!!!!!!!!!!', data);
        console.log('clients unittests dgdfghdghdghdghdyh', is_mocked, this.clients);

        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.selectedRowIndex = 0;

        if (this.client_id!=0){
          this.selectRowByClientId(this.client_id);
        }

        this.is_loading = false;
      }, (error) => {
        this.is_loading = false;
      },
      () => {

      })

  } // end getData

  selectRowByClientId(clientId: number) {
    console.log('wtfmatn!!!!!', clientId);
    const index = this.dataSource.data.findIndex(row => row.client_id === clientId);
    console.log('index!!!!!!!!!!!!!!!!!!!!!!!!',index);
    if (index !== -1) {
      this.toggleRowByIndex(index);
    }
  } // end selectRowByClientId


  getTableRecord(row: object) {
  } // end getTableRecord

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  } //end applyFilter

  dialogRefAddCampaign!: MatDialogRef<DialogAddClient>;
  addClient(is_edit:boolean, row: object) {
    let row_data = {}
    if (is_edit) {
      row_data = row;
    } else {
      row_data= {
        client_id: 0,
        client_slug: '',
        name: ''
      }
    }

    var enterAnimationDuration = '0ms';
    var exitAnimationDuration = '0ms';

    let dialogRef = this.dialog.open(DialogAddClient, {
      width: '350px',
      enterAnimationDuration,
      exitAnimationDuration,
      data: row_data
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result == 'cancel' || result == undefined) {
        console.log('we cancled')
      } else {
        this.getData();
      }
    });//end dialogRef


  } // end addClient

  deleteRow(row: CreateClientPayloadModel){
    console.log('deleteRow', row);
    const client_id = row.client_id;
    console.log('client_id',client_id)




    // this.campaignService.delete(`adserver/campaign/${campaign_id}`).subscribe(x => {
    //   //this.snackBarService.announceSackBar('Campaign Group Deleted');
    //   console.log(x)
    //   localStorage.removeItem('campaign_id')
    //   this.currentCampaignSelectService.announceCampaignSelect('');
    //   this.getData();
    // });



  } //end deleteRow

  onSelect(row: CreateClientPayloadModel) {
    console.log('onSelect', row);
    const client_id = row.client_id;
    console.log('client_id',client_id)
    localStorage.setItem('client_id', client_id.toString());
    localStorage.setItem('client_slug', row.client_slug);
    localStorage.removeItem('campaign_group_id');
    localStorage.removeItem('campaign_id');
    localStorage.removeItem('adgroup_id');
    localStorage.removeItem('ad_id');
    this.currentSelectedClientIdBehaviorService.announceCurrentClientIdBehavior(row.client_id);
    this.currentSelectedSlugBehaviorService.announceCurrentSlugBehavior(row.client_slug);
  } //end onSelect

  toggleRowByIndex(index: number) {
    const row = this.dataSource.data[index];
    console.log('wowduderow', row);
    if (row) {
      this.onSelect(row);
    }
  }




} // end of class ClientsComponent





/*---------------------------------------------
Dialog for adding a new client
---------------------------------------------*/
@Component({
  selector: 'add-client-dialog',
  templateUrl: 'add-client-dialog.html',
  imports: [
    MatCardModule,
    MatToolbarModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    MatDividerModule,
    MatListModule
],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class DialogAddClient implements OnInit, OnDestroy {


  private destroyRef = inject(DestroyRef);
  destroyed = new Subject<void>();

  myForm!: FormGroup;
  is_form_error: boolean = false;
  form_error_message: string = "";
  is_loading = false;
  is_edit = false;
  title_text = "Create Client";
  submit_text = "Create"
  client_id:number = 0;
  client_slug = "";
  name = "";




  constructor(private fb: FormBuilder,
              public dialogRef: MatDialogRef<DialogAddClient>,
              private clientService: ClientService,
              private snackBarService: SnackBarService,
              @Inject(MAT_DIALOG_DATA) public data:CreateClientPayloadModel) {}

  ngOnInit(): void {


    console.log('DialogAddClient',this.data)
    console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!',this.data)


    this.name = this.data['name'] || '';
    this.client_id = this.data['client_id'] || 0;
    this.client_slug = this.data['client_slug'] || '';


    if (this.client_id==0){
      console.log('we have empty data')
      this.is_edit = false;
    } else {
      this.is_edit = true;
      this.title_text = "Edit Client";
      this.submit_text = "Update"
    }



    // if (Object.keys(this.data).length==3) {
    //   console.log('we have empty data')
    //   this.is_edit = false;
    // } else {}

    this.myForm = this.fb.group({
      name: [this.name, [Validators.required]],
      client_id: [this.client_id, [Validators.required]],
      client_slug: [this.client_slug, [Validators.required]],
    });

  } //end ngOnInit

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  } //end ngOnDestroy

  onFocus(){
    console.log('onFocus')
    this.is_form_error = false;
    this.form_error_message = "";
  }

  onCancel() {
    this.dialogRef.close('cancel');
  }

  onSubmit() {


    this.is_loading = true;
    let form_data = this.myForm.value;
    form_data['client_id'] =  Math.floor(parseInt(form_data['client_id'], 10));
    console.log(form_data)

    if (!this.is_edit) {

      this.clientService.post(`adserver/client/create`, form_data).pipe(takeUntil(this.destroyed)).subscribe(x => {
        this.snackBarService.announceSackBar('Client Created');
        this.dialogRef.close(form_data);
      }, error => {
        console.log('error',error)
        this.dialogRef.close('cancel');

      });

    } else {

      // console.log('we are editing')
      // let endpoint = `adserver/campaign/${this.campaign_id}`;
      // console.log('endpoint',endpoint)
      // this.campaignService.put(endpoint, form_data).subscribe(x => {
      //   //this.snackBarService.announceSackBar('Client Updated');
      //   this.dialogRef.close(form_data);
      // }, error => {
      //   console.log('error',error)
      //   this.dialogRef.close('cancel');
      // });
    } //end if



  } //end onSubmit


} //end DialogAddClient
























